module.exports = require("./slicedToArray.js");


//////////////////
// WEBPACK FOOTER
// ../~/babel-runtime/helpers/sliced-to-array.js
// module id = 464
// module chunks = 0